"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const contexts_1 = require("@App/contexts");
class InputShareEdit extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "share", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.value ? this.props.value.toString() : this.props.value === 0 ? '0' : ''
        });
        Object.defineProperty(this, "widthInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "widthCheckerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getShares", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e) => {
                const prevValue = this.share;
                const inputValue = e.target.value;
                const stringArray = inputValue.split('.');
                if (stringArray.length > 2) {
                    this.share = prevValue;
                }
                else if (stringArray.length === 2 && !stringArray[0]) {
                    this.share = 0 + '.' + stringArray[1];
                }
                else if (isNaN(+stringArray[0]) || (stringArray[1] && isNaN(+stringArray[1]))) {
                    this.share = prevValue;
                }
                else if (stringArray[0].length > 2 || (stringArray[1] && stringArray[1].length > 2)) {
                    if (+stringArray[0] === 100) {
                        this.share = '100';
                        this.props.onChange(+this.share);
                        return;
                    }
                    this.share = prevValue;
                }
                else {
                    this.share = inputValue;
                    this.props.onChange(!this.share && this.share !== '0' ? null : +this.share);
                }
            }
        });
        Object.defineProperty(this, "widthController", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const widthChecker = document.getElementById(this.widthCheckerId);
                this.widthInput = widthChecker && widthChecker.offsetWidth;
            }
        });
        Object.defineProperty(this, "generateId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.widthCheckerId = `${Math.floor(Math.random() * 1000)}_${Math.floor(Math.random() * 1000)}`;
            }
        });
        (0, mobx_1.makeObservable)(this, {
            share: mobx_1.observable,
            widthInput: mobx_1.observable,
            widthCheckerId: mobx_1.observable,
            getShares: mobx_1.action,
            widthController: mobx_1.action,
            generateId: mobx_1.action,
        });
    }
    componentDidMount() {
        this.widthController();
        this.generateId();
    }
    componentDidUpdate() {
        this.widthController();
    }
    render() {
        const shareError = this.props.shareError;
        const id = `share_${Math.floor(Math.random() * 100000)}`;
        return (react_1.default.createElement("div", { className: "share-edit-component" },
            react_1.default.createElement("p", { className: 'label small' }, this.props.label),
            react_1.default.createElement("label", { htmlFor: id, className: `percent-area ${shareError ? 'invalid' : ''}` },
                react_1.default.createElement("input", { type: "string", id: id, style: { width: this.widthInput + 'px' }, value: this.share, onChange: this.getShares }),
                react_1.default.createElement("span", null, "%"),
                react_1.default.createElement("p", { className: "widthChecker", id: this.widthCheckerId }, this.share)),
            react_1.default.createElement("p", { className: "error small" }, shareError)));
    }
}
exports.default = (0, mobx_react_1.observer)(InputShareEdit);
InputShareEdit.contextType = contexts_1.StoresContext;
